
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import SwiperCore, { Autoplay } from 'swiper';
import { Navigation, Pagination } from "swiper";
import { Rating } from '@mui/material';
import { SwiperSection } from './styles/saving-section.styled';

SwiperCore.use([Autoplay]);

const GoogleSwiper: React.FC = () => {
    const datas = [
    // {
    //     id: 1,
    //     title: 'Right on time for the cold weather!',
    //     content: 'On Sept. 28th 2022 I requested gas service to Constellation to start service on Oct. 1st. Well they were able to deliver my service on time. Now I have a nice and warm house, the a/c unit uses gas for the heater function, working as expected. Great job!',
    //     score:5,
    // },
    // {
    //     id: 2,
    //     title: 'Friendly and responsive staff',
    //     content: 'Very happy we switched. We are pleased with the friendly customer service.',
    //     name: 'Anonymous | Atlanta, GA',
    //     score:5,
    // },
    {
        id:3,
        title:'Great Customer Care',
        content:'Easy and responsive customer service. Thank you for your help. Excited to see the service as we move towards billing.',
        name:'Tyler | Houston, TX',
        score:5,
    },
    {
        id:4,
        title:'Convenient and Pleasant',
        content:'Very easy online enrollment process! I appreciate the $99 early termination fee. Any other company charges outrageous amounts. Thank you Constellation!',
        name:'R. Swearingen | Fulshear, TX',
        score:5,
    },
    {
        id:5,
        title:'New Service - Great Results!',
        content:"I was looking for a better energy company to power my home with reasonable and straightforward pricing. That's what I got with Constellation. I'm happy with their service so far. A+ in my book!",
        name:'WP | Fulshear, TX',
        score:5,
    },
    {
        id:6,
        title:'Highly recommend!',
        content:"So far, I've been very pleased with Constellation! My first couple of bills have been super affordable, and I love the cost breakdowns and usage reports that are sent out regularly.",
        name:'Char | Jarrell, TX',
        score:5,
    },{
        id:7,
        title:'Billing',
        content:'I gave a 4 rating as I am new to Constellation and have only experienced 1 billing cycle. My bill was about 20% less than it was with Relient, whom I had been with for 30 years.',
        name:'Carolyn | Houston, TX',
        score:4,
    }]

    return (
        <SwiperSection>
            <Swiper navigation={true} modules={[Navigation, Pagination]} slidesPerView={'auto'} className="mySwiper" pagination={{ clickable: true, dynamicBullets:  true}} autoplay>
                {
                    datas.map((item: any) => {
                        return <SwiperSlide key={item.id}>
                            <h4>{item.title}</h4>
                            <Rating value={item.score} readOnly={true} style={{ marginTop: '10px', marginBottom: '10px' }} />
                            <p>{item.content}</p>
                            {item.name && <p style={{ fontWeight: 600, fontStyle: 'oblique', marginTop: '10px', color: '#fff' }}>{item.name}</p>}
                        </SwiperSlide>
                    })
                }
            </Swiper>
        </SwiperSection>
    );
};

export default GoogleSwiper;